const ja = {
  justNow: "たった今",
  minutesAgo: "{{count}}分前",
  hoursAgo: "{{count}}時間前",
  daysAgo: "{{count}}日前",
  loading: "読み込み中...",
  error: "エラーが発生しました",
  submit: "送信",
  cancel: "キャンセル",
  delete: "削除",
  edit: "編集",
  save: "保存",
  confirm: "確認",
  back: "戻る",
  next: "次へ",
  close: "閉じる",
  search: "検索",
  noResults: "結果がありません",
  seeMore: "もっと見る",
  required: "必須",
  logout: "ログアウト",

  app: {
    title: "ぼったくり通知 KR",
    subtitle: "韓国旅行の安全ガイド",
  },

  bottomNav: {
    home: "ホーム",
    boards: "掲示板",
    scamCheck: "判定",
    planner: "旅行",
    profile: "マイ",
    map: "地図"
  },

  mapExplore: {
    title: "地図探索",
    festival: "祭り",
    performance: "公演",
    loading: "地図データを読み込み中...",
    resultCount: "合計{{count}}件",
    viewDetail: "詳細を見る"
  },

  common: {
    like: "いいね",
    comment: "コメント",
    share: "共有",
    report: "通報",
    views: "閲覧数",
    comments: "コメント",
    likes: "いいね",
    writeComment: "コメントを書く...",
    login: "ログイン",
    logout: "ログアウト",
    signup: "会員登録",
    profile: "プロフィール",
    settings: "設定",
    notifications: "お知らせ",
    language: "言語",
    theme: "テーマ",
    dark: "ダーク",
    light: "ライト",
    all: "すべて",
    category: "カテゴリー",
    region: "地域",
    date: "日付",
    amount: "金額",
    location: "場所",
    description: "説明",
    title: "タイトル",
    content: "内容",
    photo: "写真",
    camera: "カメラ",
    gallery: "ギャラリー",
    won: "ウォン",
  },

  comment: {
    placeholder: "コメントを入力してください...",
    submit: "送信",
    empty: "まだコメントがありません",
    loginRequired: "コメントを書くにはログインが必要です",
    success: "コメントが登録されました",
    error: "コメントの登録に失敗しました",
    deleteConfirm: "コメントを削除しますか？",
    deleteSuccess: "コメントが削除されました",
    deleteError: "コメントの削除に失敗しました",
    editSuccess: "コメントが修正されました",
    replyButton: "返信",
    reply: "返信",
    editing: "修正中...",
    editPlaceholder: "コメントを修正してください...",
    replyPlaceholder: "返信を入力してください...",
    cancelEdit: "修正取消",
    cancelReply: "返信取消",
  },

  home: {
    title: "ぼったくり通知 KR",
    subtitle: "安全な韓国旅行のパートナー",
    recentReports: "最近の通報",
    recentTips: "最近のヒント",
    hotPosts: "人気の投稿",
    quickMenu: "クイックメニュー",
    scamReport: "ぼったくり通報",
    tipShare: "ヒント共有",
    scamCheck: "ぼったくり判定",
    viewAll: "すべて見る",
    noReports: "通報がありません",
    noTips: "ヒントがありません",
    welcome: "安全な韓国旅行のための\nぼったくり通知サービス",
  },

  scamCheck: {
    title: "ぼったくり判定機",
    subtitle: "適正価格かチェックしてみてください",
    category: "カテゴリー",
    selectCategory: "カテゴリーを選択",
    region: "地域",
    selectRegion: "地域を選択",
    amount: "支払った金額",
    amountPlaceholder: "金額を入力 (ウォン)",
    distance: "移動距離 (km)",
    distancePlaceholder: "距離を入力",
    checkButton: "判定する",
    result: {
      title: "判定結果",
      safe: "適正価格です",
      warning: "少し高めですが許容範囲です",
      danger: "ぼったくりの可能性が高いです！",
      safeMessage: "この金額は地域の平均価格に近いです。安心してください。",
      warningMessage: "平均より少し高いですが、場所や時間帯によっては許容範囲です。",
      dangerMessage: "平均価格を大幅に超えています。通報を検討してください。",
      averagePrice: "平均価格",
      yourPrice: "支払った金額",
      difference: "差額",
      overchargeRate: "超過率",
    },
    categories: {
      taxi: "タクシー",
      food: "飲食",
      accommodation: "宿泊",
      shopping: "ショッピング",
      tour: "ツアー",
      transport: "交通",
      etc: "その他",
    },
    regions: {
      seoul: "ソウル",
      busan: "釜山",
      daegu: "大邱",
      incheon: "仁川",
      gwangju: "光州",
      daejeon: "大田",
      ulsan: "蔚山",
      jeju: "済州",
      gyeonggi: "京畿",
      gangwon: "江原",
      chungbuk: "忠北",
      chungnam: "忠南",
      jeonbuk: "全北",
      jeonnam: "全南",
      gyeongbuk: "慶北",
      gyeongnam: "慶南",
    },
  },

  boards: {
    title: "掲示板",
    scamReports: "ぼったくり通報",
    tips: "ヒント",
    all: "すべて",
    popular: "人気",
    recent: "最新",
    myPosts: "マイ投稿",
    write: "書く",
    noPostsTitle: "投稿がありません",
    noPostsDescription: "最初の投稿を作成してみてください",
    loadMore: "もっと見る",
    filter: "フィルター",
    sort: "並べ替え",
    sortRecent: "最新順",
    sortPopular: "人気順",
    sortComments: "コメント順",
  },

  planner: {
    title: "旅行プランナー",
    myTrips: "マイ旅行",
    createTrip: "新しい旅行を作成",
    noTrips: "まだ旅行がありません",
    noTripsDesc: "新しい旅行を作成してみてください！",
    tripName: "旅行名",
    tripNamePlaceholder: "例）ソウル2泊3日",
    destination: "目的地",
    startDate: "開始日",
    endDate: "終了日",
    create: "作成",
    dDay: "D-Day",
    daysLeft: "{{count}}日後",
    daysAgo: "{{count}}日前",
    today: "今日",
    regions: {
      seoul: "ソウル",
      busan: "釜山",
      daegu: "大邱",
      incheon: "仁川",
      gwangju: "光州",
      daejeon: "大田",
      ulsan: "蔚山",
      jeju: "済州",
      gyeonggi: "京畿",
      gangwon: "江原",
      chungbuk: "忠北",
      chungnam: "忠南",
      jeonbuk: "全北",
      jeonnam: "全南",
      gyeongbuk: "慶北",
      gyeongnam: "慶南",
    },
    detail: {
      schedule: "スケジュール",
      budget: "予算",
      notes: "メモ",
      addSchedule: "スケジュール追加",
      addBudget: "予算追加",
      addNote: "メモ追加",
      totalBudget: "合計予算",
      spent: "使用済み",
      remaining: "残り",
    },
  },

  profile: {
    title: "マイページ",
    editProfile: "プロフィール修正",
    myReports: "マイ通報",
    myTips: "マイヒント",
    myComments: "マイコメント",
    myLikes: "マイいいね",
    savedPosts: "保存した投稿",
    appSettings: "アプリ設定",
    termsOfService: "利用規約",
    privacyPolicy: "プライバシーポリシー",
    version: "バージョン",
    deleteAccount: "会員退会",
    deleteAccountConfirm: "本当に退会しますか？\nすべてのデータが削除されます。",
    nickname: "ニックネーム",
    nicknamePlaceholder: "ニックネームを入力",
    bio: "自己紹介",
    bioPlaceholder: "自己紹介を入力してください",
    country: "国籍",
    countryPlaceholder: "国籍を選択",
    saveSuccess: "プロフィールが保存されました",
    saveError: "保存に失敗しました",
    loginRequired: "ログインが必要です",
    stats: {
      reports: "通報",
      tips: "ヒント",
      comments: "コメント",
      likes: "いいね",
    },
    receivedLikes: "受け取ったいいね",
    checkHistory: "判定履歴",
    myPosts: "マイ投稿",
    login: "ログイン",
    logout: "ログアウト",
    settings: "設定",
    language: "言語",
    languages: {
      ko: "한국어",
      en: "English",
      ja: "日本語"
    },
    noPosts: "投稿がありません",
    joinedAt: "登録日",
    pleaseLogin: "ログインしてすべての機能を利用してください",
    loginButton: "ログイン",
    languageSettings: "言語設定",
    appVersion: "アプリバージョン",
    notification: "通知設定",
    myFavorites: "お気に入り",
    favoriteAdded: "お気に入りに追加されました",
    favoriteRemoved: "お気に入りから削除されました"
  },

  post: {
    writeReport: "ぼったくり通報",
    writeTip: "ヒント作成",
    editReport: "通報修正",
    editTip: "ヒント修正",
    titlePlaceholder: "タイトルを入力してください",
    contentPlaceholder: "内容を入力してください",
    locationPlaceholder: "場所を入力 (例: 明洞、江南駅)",
    chargedAmount: "請求された金額",
    chargedAmountPlaceholder: "実際に支払った金額",
    fairAmount: "適正金額",
    fairAmountPlaceholder: "適正と思われる金額",
    addPhoto: "写真追加",
    maxPhotos: "最大5枚まで",
    submitReport: "通報する",
    submitTip: "ヒント共有する",
    updateReport: "通報修正する",
    updateTip: "ヒント修正する",
    success: "投稿が登録されました",
    updateSuccess: "投稿が修正されました",
    error: "投稿の登録に失敗しました",
    deleteConfirm: "この投稿を削除しますか？",
    deleteSuccess: "投稿が削除されました",
    deleteError: "投稿の削除に失敗しました",
    reportSuccess: "通報が完了しました",
  },

  report: {
    title: "ぼったくり通報",
    category: "カテゴリー",
    selectCategory: "カテゴリーを選択してください",
    region: "地域",
    selectRegion: "地域を選択してください",
    location: "詳細場所",
    locationPlaceholder: "具体的な場所を入力してください",
    reportTitle: "タイトル",
    titlePlaceholder: "通報タイトルを入力してください",
    content: "詳細内容",
    contentPlaceholder: "状況を詳しく説明してください",
    chargedAmount: "請求された金額 (ウォン)",
    chargedPlaceholder: "実際に支払った金額",
    fairAmount: "適正金額 (ウォン)",
    fairPlaceholder: "適正と思われる金額",
    photos: "証拠写真",
    addPhoto: "写真追加",
    submit: "通報する",
    success: "通報が登録されました",
    error: "通報の登録に失敗しました",
  },

  reportDetail: {
    title: "通報詳細",
    chargedAmount: "請求金額",
    fairAmount: "適正金額",
    overchargeRate: "超過率",
    location: "場所",
    date: "日付",
    like: "いいね",
    comment: "コメント",
    share: "共有",
    deleteConfirm: "この通報を削除しますか？",
    editButton: "修正",
    deleteButton: "削除",
    reportButton: "通報",
  },

  tip: {
    title: "ヒント",
    detailTitle: "ヒント",
    category: "カテゴリー",
    selectCategory: "カテゴリーを選択してください",
    region: "地域",
    selectRegion: "地域を選択してください",
    location: "場所",
    locationPlaceholder: "場所を入力してください",
    tipTitle: "タイトル",
    titlePlaceholder: "ヒントのタイトルを入力してください",
    content: "内容",
    contentPlaceholder: "ヒントを詳しく書いてください",
    photos: "写真",
    addPhoto: "写真追加",
    submit: "共有する",
    success: "ヒントが登録されました",
    error: "ヒントの登録に失敗しました",
    like: "いいね",
    comment: "コメント",
    share: "共有",
    deleteConfirm: "このヒントを削除しますか？",
    editButton: "修正",
    deleteButton: "削除",
    categoryAccommodation: "宿泊",
    categoryFood: "飲食",
    categoryTransport: "交通",
    categoryTour: "ツアー",
    categoryShopping: "ショッピング",
    categoryTaxi: "タクシー",
    categoryEtc: "その他",
  },

  category: {
    all: "すべて",
    taxi: "タクシー",
    food: "飲食",
    accommodation: "宿泊",
    shopping: "ショッピング",
    tour: "ツアー",
    transport: "交通",
    etc: "その他",
  },

  auth: {
    login: "ログイン",
    signup: "会員登録",
    logout: "ログアウト",
    email: "メール",
    emailPlaceholder: "メールアドレスを入力",
    password: "パスワード",
    passwordPlaceholder: "パスワードを入力",
    passwordConfirm: "パスワード確認",
    passwordConfirmPlaceholder: "パスワードをもう一度入力",
    nickname: "ニックネーム",
    nicknamePlaceholder: "ニックネームを入力",
    loginButton: "ログイン",
    signupButton: "会員登録",
    loginSuccess: "ログインしました",
    signupSuccess: "会員登録が完了しました",
    loginError: "ログインに失敗しました",
    signupError: "会員登録に失敗しました",
    noAccount: "アカウントをお持ちでないですか？",
    hasAccount: "すでにアカウントをお持ちですか？",
    goToSignup: "会員登録する",
    goToLogin: "ログインする",
    googleLogin: "Googleでログイン",
    kakaoLogin: "カカオでログイン",
    or: "または",
    forgotPassword: "パスワードを忘れた場合",
    resetPassword: "パスワードリセット",
    resetPasswordSuccess: "リセットメールを送信しました",
    resetPasswordError: "メール送信に失敗しました",
    termsAgree: "利用規約に同意します",
    privacyAgree: "プライバシーポリシーに同意します",
    allAgree: "全体同意",
  },

  validation: {
    emailRequired: "メールアドレスを入力してください",
    emailInvalid: "正しいメール形式で入力してください",
    passwordRequired: "パスワードを入力してください",
    passwordMin: "パスワードは6文字以上で入力してください",
    passwordMismatch: "パスワードが一致しません",
    nicknameRequired: "ニックネームを入力してください",
    nicknameMin: "ニックネームは2文字以上で入力してください",
    nicknameMax: "ニックネームは20文字以下で入力してください",
    titleRequired: "タイトルを入力してください",
    contentRequired: "内容を入力してください",
    categoryRequired: "カテゴリーを選択してください",
    regionRequired: "地域を選択してください",
    amountRequired: "金額を入力してください",
    amountInvalid: "正しい金額を入力してください",
    locationRequired: "場所を入力してください",
    termsRequired: "利用規約に同意してください",
  },

  feed: {
    all: "すべて",
    scamReports: "ぼったくり通報",
    tips: "ヒント",
    trending: "トレンド",
    latest: "最新",
    following: "フォロー",
  },

  currency: {
    krw: "韓国ウォン",
    usd: "米ドル",
    jpy: "日本円",
    cny: "中国元",
    eur: "ユーロ",
    thb: "タイバーツ",
    vnd: "ベトナムドン",
    twd: "台湾ドル",
    php: "フィリピンペソ",
    myr: "マレーシアリンギット",
    sgd: "シンガポールドル",
    idr: "インドネシアルピア",
    hkd: "香港ドル",
    gbp: "イギリスポンド",
  },
};

export default ja;
